import { uuidv4 } from './uuid';

export const createEmptyStack = (title = "") => ({
  id: uuidv4(),
  title,
  timeleft: "0h",
  tasks: [],
  completions: [],
});

const ensureStackShape = (stack) => ({
  id: stack.id || uuidv4(),
  title: stack.title == null ? "" : stack.title,
  timeleft: stack.timeleft == null ? "0h" : stack.timeleft,
  tasks: Array.isArray(stack.tasks) ? stack.tasks : [],
  completions: Array.isArray(stack.completions) ? stack.completions : [],
});

/**
 * Normalize legacy Task[], v2 single-stack objects, and v3 multi-stack documents
 * into { stacks: Stack[] }.
 */
export const normalizeDocument = (raw) => {
  if (raw == null) {
    return { stacks: [createEmptyStack()] };
  }

  if (Array.isArray(raw)) {
    return {
      stacks: [ensureStackShape({ title: "", timeleft: "", tasks: raw })],
    };
  }

  if (Array.isArray(raw.stacks)) {
    const stacks = raw.stacks.map(ensureStackShape);
    return { stacks: stacks.length > 0 ? stacks : [createEmptyStack()] };
  }

  if (Array.isArray(raw.tasks)) {
    return {
      stacks: [
        ensureStackShape({
          title: raw.title,
          timeleft: raw.timeleft,
          tasks: raw.tasks,
        }),
      ],
    };
  }

  return { stacks: [createEmptyStack()] };
};

/**
 * Dual-write payload: versioned stacks[] plus top-level fields mirrored from
 * the first stack so older clients keep working.
 */
export const buildUploadPayload = (stacks) => {
  const safeStacks = (stacks && stacks.length > 0 ? stacks : [createEmptyStack()]).map(ensureStackShape);
  const first = safeStacks[0];
  return {
    version: 3,
    title: first.title,
    timeleft: first.timeleft,
    tasks: first.tasks,
    stacks: safeStacks,
  };
};
